import {
    AGENT_ACCESS_GRANT_TARGET_ID_LIMIT,
    AgentAccessGrantTarget,
} from "@common/schemas/domains/agentAccess/agent-access-grant.schema";

export type AgentAccessTargetType = AgentAccessGrantTarget["type"];

export interface AgentAccessTargetFormValues {
    targetType: AgentAccessTargetType;
    organizationIds: string[];
    workspaceIds: string[];
}

export function buildAgentAccessGrantTarget(
    values: AgentAccessTargetFormValues,
): AgentAccessGrantTarget {
    if (values.targetType === "organizations") {
        return {
            type: "organizations",
            organizationIds: values.organizationIds,
        };
    }

    if (values.targetType === "workspaces") {
        return {
            type: "workspaces",
            workspaceIds: values.workspaceIds,
        };
    }

    return { type: "all" };
}

export function getAgentAccessTargetValidationMessage(
    values: AgentAccessTargetFormValues,
): string | null {
    if (values.targetType === "organizations") {
        if (values.organizationIds.length === 0) {
            return "Select at least one organization";
        }
        if (
            values.organizationIds.length > AGENT_ACCESS_GRANT_TARGET_ID_LIMIT
        ) {
            return `Select no more than ${AGENT_ACCESS_GRANT_TARGET_ID_LIMIT} organizations`;
        }
    }

    if (values.targetType === "workspaces") {
        if (values.workspaceIds.length === 0) {
            return "Select at least one workspace";
        }
        if (values.workspaceIds.length > AGENT_ACCESS_GRANT_TARGET_ID_LIMIT) {
            return `Select no more than ${AGENT_ACCESS_GRANT_TARGET_ID_LIMIT} workspaces`;
        }
    }

    return null;
}
